/**
 * Represents detailed information about a user's phone number.
 *
 * @property canReceiveSMS - Indicates if the phone number is capable of receiving SMS messages.
 * @property carrierName - The name of the carrier associated with the phone number (optional).
 * @property carrierType - The type of carrier (e.g., mobile, landline) for the phone number (optional).
 * @property carrierTypeDescription - A human-readable description of the carrier type (optional).
 * @property isValid - Indicates if the phone number is valid.
 */
export interface IPhoneNumberInfo {
  canReceiveSMS: boolean
  carrierName?: string
  carrierType?: string
  carrierTypeDescription?: string
  isValid: boolean
}

/**
 * @param id the user id
 * @param name the name of the selected user
 * @param email the used to display the email of selected user
 * @param photo the url of the profile photo of selected user
 * @param phone the used to display the phone number of user
 */
export interface UserDetails {
  countryCode?: string
  displayName?: string
  email?: string
  id: string
  name?: string
  online?: boolean
  phone?: string
  phoneNumberInfo?: IPhoneNumberInfo
  photo?: string
  role?: UserRole
  username?: string
}

export enum UserStatus {
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
  REGISTERED = 'Registered'
}

export enum UserRole {
  CarrierSalesRep = 'CarrierSalesRep',
  CustomerSalesRep = 'CustomerSalesRep',
  Dispatcher = 'Dispatcher',
  Driver = 'Driver',
  OwnerOperator = 'OwnerOperator',
  ShipperSalesRep = 'ShipperSalesRep'
}

export enum CreatedVia {
  ChaineWebApp = 'ChaineWebApp',
  Integration = 'Integration'
}
